import { ReturnProduct } from "../draft-return/draft-return-items";
import { AllowedExchangeTypes } from "../return-flow";
import { ExchangeGroup, PriceDifferenceType } from "../team";

export function getNonAdvancedExchangeType(
  returnedProductVariantId: string,
  exchangedItemVariantId: string | undefined | null,
  exchangeGroup?: ExchangeGroup | null,
): keyof AllowedExchangeTypes {
  return exchangeGroup
    ? "exchangeGroups"
    : exchangedItemVariantId === returnedProductVariantId
      ? "sameItem"
      : "variant";
}

export function getVariantExchangePriceDifference(
  exchangeType: keyof AllowedExchangeTypes,
  product: ReturnProduct,
  differentPricedVariantExchanges: boolean,
  variantExchangeProductTags: string[],
  exchangeGroup?: ExchangeGroup | null,
): PriceDifferenceType {
  if (exchangeType === "advanced") {
    return "apply";
  }

  const exchangeGroupPriceDifference =
    exchangeType === "exchangeGroups" &&
    exchangeGroup?.priceDifference === "apply";

  const variantExchangePriceDifference =
    exchangeType !== "sameItem" &&
    exchangeType !== "exchangeGroups" &&
    differentPricedVariantExchanges &&
    (!variantExchangeProductTags.length ||
      variantExchangeProductTags.some((tag) =>
        product.productTags.includes(tag),
      ));

  return exchangeGroupPriceDifference || variantExchangePriceDifference
    ? "apply"
    : "ignore";
}
